export default "__VITE_PUBLIC_ASSET__de29aef7__"